<template>
  <div class="gallery-skeleton-loader">
    <div class="gallery-skeleton-loader__carousel">
      <g-skeleton />
      <g-skeleton />
      <g-skeleton />
      <g-skeleton />
      <g-skeleton />
    </div>
    <div class="gallery-skeleton-loader__main-img">
      <g-skeleton />
    </div>
  </div>
</template>

<style lang="scss" scoped>
/* Cloudinary Gallery Breakpoints */
$gallery-bp-sm: 737px;
$gallery-bp-md: 768px;
$gallery-bp-lg: 1023px;
$gallery-bp-xl: 1285px;

.gallery-skeleton-loader {
  display: flex;
  gap: 5px;

  @media screen and (min-width: $gallery-bp-md) {
    flex-direction: column-reverse;
  }

  @media screen and (min-width: $gallery-bp-lg) {
    flex-direction: row;
  }

  &__carousel {
    display: none;

    // stylelint-disable-next-line selector-type-no-unknown
    g-skeleton {
      width: 80px;
      aspect-ratio: 1 / 1;

      @media screen and (min-width: $gallery-bp-lg) {
        height: 80px;
      }

      &:nth-child(4),
      &:nth-child(5) {
        @media screen and (min-width: $gallery-bp-lg) and (max-width: $gallery-bp-xl) {
          display: none;
        }
      }
    }

    @media screen and (min-width: $gallery-bp-md) {
      display: flex;
      gap: 8px;
      flex-direction: row;
      justify-content: center;
    }

    @media screen and (min-width: $gallery-bp-lg) {
      flex-direction: column;
      justify-content: flex-start;
    }
  }

  &__main-img {
    width: 100%;
    aspect-ratio: 1 / 1;

    @media screen and (min-width: $gallery-bp-sm) {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
